module.exports = __webpack_public_path__ + "img/sup_deposit_ccpayment1.31b4c806.jpg";